import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-detail-guide',
  templateUrl: './table-detail-guide.component.html',
  styleUrls: ['./table-detail-guide.component.scss']
})
export class TableDetailGuideComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
